import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FiTrendingUp, FiDollarSign, FiUsers, FiTarget,
  FiCheck, FiX, FiAward, FiBarChart2
} from "react-icons/fi";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');

  .rely-root {
    font-family: 'Montserrat', sans-serif;
    background: linear-gradient(135deg, #e0e5ec 0%, #d1d6df 100%);
    min-height: 100%;
    padding: 6px 5px;
  }
  .rely-root *, .rely-root *::before, .rely-root *::after { box-sizing: border-box; }
  .rely-page { max-width: 1280px; margin: 0 auto; display: flex; flex-direction: column; gap: 24px; }

  .rely-section-label {
    font-size: 12px; font-weight: 800;
    background: linear-gradient(135deg, #2563eb, #8b5cf6);
    background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    text-transform: uppercase; letter-spacing: 0.12em;
    display: flex; align-items: center; gap: 12px;
  }
  .rely-section-label::after {
    content: ''; flex: 1; height: 2px;
    background: linear-gradient(90deg, #2563eb, #8b5cf6, transparent);
    border-radius: 99px;
  }

  .rely-metrics { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
  .rely-metric-card {
    background: linear-gradient(145deg, #e8edf5, #dce1e8);
    border-radius: 9px; padding: 12px 14px;
    box-shadow: 8px 8px 14px #8f95a0, -5px -5px 10px #ffffff;
    display: flex; flex-direction: column; gap: 10px;
    position: relative; overflow: hidden;
  }
  .rely-metric-card::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 5px; border-radius: 28px 28px 0 0;
  }
  .rely-metric-card.blue::before   { background: linear-gradient(90deg, #3b82f6, #60a5fa); }
  .rely-metric-card.green::before  { background: linear-gradient(90deg, #10b981, #34d399); }
  .rely-metric-card.amber::before  { background: linear-gradient(90deg, #f59e0b, #fbbf24); }
  .rely-metric-card.purple::before { background: linear-gradient(90deg, #8b5cf6, #a78bfa); }
  .rely-metric-top { display: flex; align-items: center; justify-content: space-between; }
  .rely-metric-label {
    font-size: 11px; font-weight: 800;
    background: linear-gradient(135deg, #2563eb, #8b5cf6);
    background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    text-transform: uppercase; letter-spacing: 0.08em;
  }
  .rely-metric-icon {
    width: 36px; height: 36px; border-radius: 14px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
    box-shadow: inset -2px -2px 5px rgba(255,255,255,0.7), inset 2px 2px 5px rgba(0,0,0,0.08);
  }
  .rely-metric-icon.blue   { background: linear-gradient(145deg, #dbeafe, #eff6ff); color: #3b82f6; }
  .rely-metric-icon.green  { background: linear-gradient(145deg, #dcfce7, #f0fdf4); color: #10b981; }
  .rely-metric-icon.amber  { background: linear-gradient(145deg, #fef3c7, #fffbeb); color: #f59e0b; }
  .rely-metric-icon.purple { background: linear-gradient(145deg, #ede9fe, #f5f3ff); color: #8b5cf6; }
  .rely-metric-val { font-size: clamp(18px, 2.5vw, 22px); font-weight: 900; color: #1e293b; }
  .rely-metric-unit { font-size: 10px; font-weight: 700; color: #94a3b8; margin-top: 4px; }

  .rely-royalty {
    background: linear-gradient(145deg, #e8edf5, #dce1e8);
    border-radius: 9px; padding: 18px 18px 16px;
    box-shadow: 10px 10px 18px #8f95a0, -6px -6px 12px #ffffff;
    position: relative; overflow: hidden;
  }
  .rely-royalty::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 4px;
    background: linear-gradient(90deg, #f59e0b, #fbbf24, #fcd34d);
    border-radius: 24px 24px 0 0;
  }
  .rely-royalty-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; margin-bottom: 18px; }
  .rely-royalty-title {
    font-size: 13px; font-weight: 900;
    background: linear-gradient(135deg, #2563eb, #8b5cf6);
    background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    text-transform: uppercase; letter-spacing: 0.06em;
    display: flex; align-items: center; gap: 8px;
  }
  .rely-royalty-title-bar {
    width: 6px; height: 20px; border-radius: 99px;
    background: linear-gradient(180deg, #fbbf24, #f59e0b);
    box-shadow: 0 2px 8px rgba(245,158,11,0.4);
  }
  .rely-royalty-stats { display: grid; grid-template-columns: 1fr; gap: 12px; margin-bottom: 18px; }
  .rely-rstat {
    background: linear-gradient(145deg, #f0f4f9, #e8edf5);
    border-radius: 9px; padding: 14px;
    box-shadow: inset 2px 2px 5px rgba(0,0,0,0.05), inset -2px -2px 5px rgba(255,255,255,0.7);
  }
  .rely-rstat-label { font-size: 10px; font-weight: 800; color: #64748b; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 8px; }
  .rely-rstat-val { font-size: clamp(16px, 2.2vw, 20px); font-weight: 900; }
  .rely-rstat-val.amber { color: #f59e0b; }
  .rely-rstat-val.blue  { color: #3b82f6; }
  .rely-rstat-check {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 4px 12px; border-radius: 99px; font-size: 11px; font-weight: 800; margin-top: 8px;
    background: linear-gradient(145deg, #e8edf5, #dce1e8);
    box-shadow: inset 1px 1px 2px rgba(255,255,255,0.7), inset -1px -1px 2px rgba(0,0,0,0.05);
  }
  .rely-rstat-check.met  { color: #10b981; }
  .rely-rstat-check.miss { color: #ef4444; }

  .rely-rule-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 20px; }
  @media (max-width: 540px) { .rely-rule-grid { grid-template-columns: 1fr; } }
  .rely-rule-box {
    background: linear-gradient(145deg, #f0f4f9, #e8edf5);
    border-radius: 9px; padding: 18px;
    box-shadow: inset 2px 2px 5px rgba(0,0,0,0.05), inset -2px -2px 5px rgba(255,255,255,0.7);
  }
  .rely-rule-title { font-size: 13px; font-weight: 800; color: #1e293b; margin-bottom: 10px; }
  .rely-rule-progress-track {
    height: 8px; background: linear-gradient(145deg, #dce1e8, #e8edf5); border-radius: 99px;
    overflow: hidden; margin-bottom: 8px;
    box-shadow: inset 1px 1px 2px rgba(0,0,0,0.1), inset -1px -1px 2px rgba(255,255,255,0.5);
  }
  .rely-rule-progress-fill {
    height: 100%; border-radius: 99px;
    background: linear-gradient(90deg, #fbbf24, #f59e0b);
    transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .rely-rule-progress-fill.full { background: linear-gradient(90deg, #10b981, #059669); }
  .rely-rule-amounts { display: flex; justify-content: space-between; font-size: 12px; font-weight: 700; color: #64748b; margin-bottom: 8px; }
  .rely-rule-status {
    display: inline-flex; align-items: center; gap: 5px; font-size: 11px; font-weight: 800;
    padding: 4px 12px; border-radius: 99px; margin-top: 8px;
    background: linear-gradient(145deg, #e8edf5, #dce1e8);
    box-shadow: inset 1px 1px 2px rgba(255,255,255,0.7), inset -1px -1px 2px rgba(0,0,0,0.05);
  }
  .rely-rule-status.met  { color: #10b981; }
  .rely-rule-status.miss { color: #ef4444; }

  .rely-reason-banner {
    background: linear-gradient(145deg, #fef2f2, #fee2e2);
    border: 1px solid #fecaca; border-radius: 16px; padding: 14px 18px;
    font-size: 13px; font-weight: 700; color: #dc2626;
    display: flex; align-items: flex-start; gap: 10px; margin-bottom: 20px;
  }

  .rely-tier-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
  @media (max-width: 640px) { .rely-tier-grid { grid-template-columns: 1fr; } }
  .rely-tier-card {
    background: linear-gradient(145deg, #f0f4f9, #e8edf5);
    border-radius: 9px; padding: 20px;
    box-shadow: 8px 8px 16px #8f95a0, -4px -4px 10px #ffffff;
  }
  .rely-tier-card.current {
    background: linear-gradient(145deg, #fffbeb, #fef3c7);
    box-shadow: 0 0 0 2px #f59e0b, 12px 12px 24px #8f95a0;
  }
  .rely-tier-name {
    font-size: 15px; font-weight: 800;
    background: linear-gradient(135deg, #2563eb, #8b5cf6);
    background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    text-transform: capitalize; margin-bottom: 12px;
  }
  .rely-tier-detail {
    font-size: 12px; font-weight: 700; color: #64748b; padding: 6px 0;
    display: flex; align-items: center; gap: 8px; border-bottom: 1px solid rgba(0,0,0,0.05);
  }
  .rely-tier-detail:last-of-type { border-bottom: none; }
  .rely-tier-royalty { font-size: 14px; font-weight: 900; color: #1e293b; margin-top: 10px; }
  .rely-eligible-badge {
    display: inline-flex; align-items: center; gap: 6px; margin-top: 12px;
    padding: 6px 14px; border-radius: 99px; background: linear-gradient(135deg, #f59e0b, #fbbf24);
    font-size: 11px; font-weight: 800; color: #0f172a; box-shadow: 0 2px 8px rgba(245,158,11,0.3);
  }

  .rely-skeleton { display: flex; flex-direction: column; gap: 24px; padding: 20px; }
  .rely-skel {
    border-radius: 32px; background: #dce1e8; position: relative; overflow: hidden;
    box-shadow: 8px 8px 16px #8f95a0, -8px -8px 16px #ffffff; height: 200px;
  }
  .rely-skel::after {
    content: ''; position: absolute; inset: 0;
    background: linear-gradient(90deg, transparent 25%, rgba(255,255,255,0.5) 50%, transparent 75%);
    background-size: 200% 100%; animation: rely-shimmer 1.4s infinite;
  }
  @keyframes rely-shimmer { from { background-position: -200% 0; } to { background-position: 200% 0; } }

  .rely-error {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    padding: 60px 40px; text-align: center; gap: 20px;
    background: linear-gradient(135deg, #1e3a5f, #2563eb); border-radius: 40px; margin: 40px;
    box-shadow: 20px 20px 40px #8f95a0, -10px -10px 20px #ffffff;
  }
  .rely-error-icon { font-size: 64px; }
  .rely-error-text { font-size: 18px; font-weight: 700; color: #ffffff; }
`;

const RoyaltyEligibility = () => {
  const [data, setData] = useState(null);
  const [royalty, setRoyalty] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };
        const [dashRes, royaltyRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/dashboard/lbbp-partner`, { headers }),
          axios.get(`${process.env.REACT_APP_API_URL}/share/royalty-eligibility`, { headers }),
        ]);
        setData(dashRes.data);
        setRoyalty(royaltyRes.data);
      } catch (err) {
        console.error("Failed to fetch royalty eligibility:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return (
    <div className="rely-root">
      <style>{styles}</style>
      <div className="rely-skeleton">
        <div className="rely-skel" />
        <div className="rely-skel" />
      </div>
    </div>
  );

  if (!royalty) return (
    <div className="rely-root">
      <style>{styles}</style>
      <div className="rely-error">
        <div className="rely-error-icon">😕</div>
        <div className="rely-error-text">Unable to load royalty eligibility</div>
      </div>
    </div>
  );

  return (
    <div className="rely-root">
      <style>{styles}</style>
      <div className="rely-page">

        {data && (
          <>
            <div className="rely-section-label">
              <FiBarChart2 size={14} /> Key Metrics
            </div>
            <div className="rely-metrics">
              <MetricCard color="blue" title="Total Loan Pay" value={`₹${data.investments.totalInvested.toLocaleString("en-IN")}`} icon={<FiDollarSign size={18} />} />
              <MetricCard color="green" title="Loan Plans" value={data.investments.sharePurchases} unit="plans" icon={<FiTarget size={18} />} />
              <MetricCard color="amber" title="Pending EMI" value={data.investments.pendingROI} unit="plans" icon={<FiTrendingUp size={18} />} />
              <MetricCard color="purple" title="Direct Team" value={data.team.directReferrals} unit="members" icon={<FiUsers size={18} />} />
            </div>
          </>
        )}

        <div className="rely-royalty">
          <div className="rely-royalty-header">
            <div className="rely-royalty-title">
              <div className="rely-royalty-title-bar" />
              <FiAward size={18} style={{ color: "#f59e0b" }} />
              Royalty Eligibility Status
            </div>
          </div>

          <div className="rely-royalty-stats">
            <div className="rely-rstat">
              <div className="rely-rstat-label">Current Tier</div>
              <div className="rely-rstat-val amber">{royalty.tier || "—"}</div>
              <div style={{ fontSize: 12, color: "#94a3b8", fontWeight: 700, marginTop: 4 }}>Royalty Rate</div>
            </div>
            <div className="rely-rstat">
              <div className="rely-rstat-label">Active Direct Members</div>
              <div className="rely-rstat-val blue">
                {royalty.activeDirectMembers}/{royalty.minimumRequired || 3}
              </div>
              <span className={`rely-rstat-check ${royalty.directMembersMet ? "met" : "miss"}`}>
                {royalty.directMembersMet
                  ? <><FiCheck size={12} /> Met</>
                  : <><FiX size={12} /> Need {Math.max((royalty.minimumRequired || 3) - (royalty.activeDirectMembers || 0), 0)} more</>
                }
              </span>
            </div>
            <div className="rely-rstat">
              <div className="rely-rstat-label">Loan Pay Progress</div>
              <div style={{ fontSize: 13, color: "#10b981", fontWeight: 700, marginTop: 4 }}>
                My Loan Pay ({royalty?.currentMonthName}): {royalty?.currentMonthPersonalInvestment}
              </div>
            </div>
          </div>

          <div className="rely-rule-grid">
            <RuleBox
              title={`Team Loan Pay (${royalty?.currentMonthName} ${royalty?.currentYear})`}
              current={royalty.currentMonthDownlineInvestment || 0}
              target={royalty.minimumTeamInvestment || 100000}
              met={royalty.teamInvestmentMet}
              format="currency"
            />
            <RuleBox
              title="Active Downline (Total)"
              current={royalty.totalActiveDownline || 0}
              target={royalty.minimumActiveDownline || 30}
              met={royalty.activeDownlineMet}
            />
          </div>

          {!royalty.eligible && royalty.reason && (
            <div className="rely-reason-banner">
              <FiX size={16} style={{ flexShrink: 0, marginTop: 1 }} />
              {royalty.reason}
            </div>
          )}

          {royalty.tiers && (
            <>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 16 }}>
                Eligible Tiers
              </div>
              <div className="rely-tier-grid">
                {Object.entries(royalty.tiers).map(([tier, details]) => (
                  <div key={tier} className={`rely-tier-card ${details.current ? "current" : ""}`}>
                    <div className="rely-tier-name">{tier}</div>
                    <div className="rely-tier-detail"><FiBarChart2 size={13} /> {details.investmentRatio}% Loan Pay</div>
                    <div className="rely-tier-detail"><FiUsers size={13} /> {details.activeMembers} active members</div>
                    <div className="rely-tier-royalty">💰 {details.royalty} royalty</div>
                    {details.current && (
                      <div className="rely-eligible-badge">
                        <FiCheck size={12} /> Eligible
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

const MetricCard = ({ color, title, value, unit, icon }) => (
  <div className={`rely-metric-card ${color}`}>
    <div className="rely-metric-top">
      <div className="rely-metric-label">{title}</div>
      <div className={`rely-metric-icon ${color}`}>{icon}</div>
    </div>
    <div>
      <div className="rely-metric-val">{value}</div>
      {unit && <div className="rely-metric-unit">{unit}</div>}
    </div>
  </div>
);

const RuleBox = ({ title, current, target, met, format }) => {
  const pct = Math.min(Math.round((current / target) * 100), 100);
  const fmt = (v) => format === "currency"
    ? `₹${v.toLocaleString("en-IN")}`
    : v.toLocaleString("en-IN");
  return (
    <div className="rely-rule-box">
      <div className="rely-rule-title">{title}</div>
      <div className="rely-rule-amounts">
        <span>{fmt(current)}</span>
        <span>{fmt(target)}</span>
      </div>
      <div className="rely-rule-progress-track">
        <div className={`rely-rule-progress-fill ${pct >= 100 ? "full" : ""}`} style={{ width: `${pct}%` }} />
      </div>
      <span className={`rely-rule-status ${met ? "met" : "miss"}`}>
        {met ? <><FiCheck size={12} /> Met</> : <><FiX size={12} /> Not met</>}
      </span>
    </div>
  );
};

export default RoyaltyEligibility;
